import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'IgnoreIpRange'

export const GET_IP_RANGE_LIST_ASYNC = createAsyncTypes('GET_IP_RANGE_LIST', typeKey)
export const CREATE_IP_RANGE_ASYNC = createAsyncTypes('CREATE_IP_RANGE', typeKey)
export const UPDATE_IP_RANGE_ASYNC = createAsyncTypes('UPDATE_IP_RANGE', typeKey)
export const DELETE_IP_RANGE_ASYNC = createAsyncTypes('DELETE_IP_RANGE', typeKey)

export const CHANGE_SEARCH_INPUT = `${typeKey}/CHANGE_SEARCH_INPUT`
export const CHANGE_WITHIN_LAST_DAYS = `${typeKey}/CHANGE_WITHIN_LAST_DAYS`
export const CLEAR_ALL_FILTERS = `${typeKey}/CLEAR_ALL_FILTERS`
export const CHANGE_SELECTED_ITEMS = `${typeKey}/CHANGE_SELECTED_ITEMS`
export const CHANGE_IP_MODAL_FIELD = `${typeKey}/CHANGE_IP_MODAL_FIELD`
export const SET_IP_MODAL_DATA = `${typeKey}/SET_IP_MODAL_DATA`

export const WITHIN_LAST_DAYS_VALUES = {
  LAST_30_DAYS: 30,
  LAST_90_DAYS: 90,
  LAST_180_DAYS: 180,
}

export const WITHIN_LAST_DAYS_OPTIONS = [
  { label: 'Last 30 days', value: WITHIN_LAST_DAYS_VALUES.LAST_30_DAYS },
  { label: 'Last 90 days', value: WITHIN_LAST_DAYS_VALUES.LAST_90_DAYS },
  { label: 'Last 180 days', value: WITHIN_LAST_DAYS_VALUES.LAST_180_DAYS },
]

export const DEFAULT_IP_MODAL_DATA = {
  id: null,
  loader: false,
  error: null,
  name: '',
  rawValues: '',
  description: '',
  isApplyForPastCampaigns: true,
}
